module.exports = __webpack_public_path__ + "static/media/POSITIVE.87afb2b8.svg";